import { httpClient, HttpMethod } from './http-client';
import { Auth0AppUser } from '../@types/user.type';

interface CreateAuthUserPayload {
  email: string;
  given_name: string;
  family_name: string;
  name: string;
  email_verified: boolean;
  blocked: boolean;
  user_metadata: {
    picture: string;
  };
}

interface UpdateAuthUserPayload {
  email?: string;
  given_name?: string;
  family_name?: string;
  name?: string;
  email_verified?: boolean;
  blocked?: boolean;
  account_enabled?: boolean;
  user_metadata?: {
    picture?: string;
  };
}

export async function createClientAuthSide(
  email: string,
  givenName: string,
  familyName: string,
  picture: string
): Promise<Auth0AppUser> {
  const name = givenName + ' ' + familyName;
  const emailVerified = false;
  const blocked = false;

  const authUser: CreateAuthUserPayload = {
    email: email,
    given_name: givenName,
    family_name: familyName,
    name: name,
    email_verified: emailVerified,
    blocked: blocked,
    user_metadata: {
      picture: picture
    }
  };

  return httpClient<Auth0AppUser>('/authUsers', HttpMethod.Post, authUser);
}

export async function updateAuthUserById(userId: string, authUser: UpdateAuthUserPayload): Promise<Auth0AppUser> {
  return httpClient<Auth0AppUser>(`/authUsers/${userId}`, HttpMethod.Patch, authUser);
}

export async function getAuthUserByEmail(email: string): Promise<Auth0AppUser[]> {
  return httpClient<Auth0AppUser[]>(`/authUsers/byEmail/${email}`, HttpMethod.Get);
}

export async function getAuthUserById(userId: string): Promise<Auth0AppUser> {
  return httpClient<Auth0AppUser>(`/authUsers/${userId}`, HttpMethod.Get);
}

export async function sendWelcomeEmail(userId: string): Promise<void> {
  return httpClient<void>(`/authUsers/welcomeEmail/${userId}`, HttpMethod.Post);
}

export const deleteAuthUserById = async (userId: string): Promise<void> => {
  return httpClient<void>(`/authUsers/${userId}`, HttpMethod.Delete);
};
